import { Product } from '@interactify-live/khanoumi-player/dist/types';
import { CardImage, Pricing } from '../product-card';
interface Props {
  product: Product;
}
const ProductCard: React.FC<Props> = ({
  product
}) => {
  const {
    brandName,
    effectivePrice,
    basePrice,
    discountPercentage,
    productDescription,
    productImages,
    isSalable
  } = product || {};
  const isLoading = product.isLoading as boolean;
  const image = productImages?.[0];
  return <div className='flex h-full min-w-60 max-w-60 cursor-pointer items-center gap-1 rounded bg-white px-2 py-1' data-sentry-component="ProductCard" data-sentry-source-file="product-card.tsx">
            {isLoading ? <>
                    <div className='h-18 w-18 animate-pulse bg-gray-100' />

                    <div className='flex flex-col'>
                        <div className='h-10 w-[148px] animate-pulse bg-gray-100' />
                        <div className='mr-auto h-10 w-4/5 animate-pulse bg-gray-100 lg:h-12' />
                    </div>
                </> : <>
                    <CardImage alt={`${productDescription} ${brandName}`} image={image} srcSet={{
        desktop: 72,
        mobile: 72
      }} imageClassName='aspect-square w-18 h-18' parentClassName='h-fit shrink-0' width={72} height={72} />

                    <div className='flex grow flex-col'>
                        <p className='line-clamp-2 min-h-10 text-wrap text-caption-12'>{productDescription}</p>
                        {isSalable ? <Pricing basePrice={+basePrice} discountPercent={+discountPercentage} effectivePrice={+effectivePrice} className='mr-auto h-10 lg:h-12' /> : <span className='flex h-10 items-end justify-end text-caption-10 font-medium lg:h-12 lg:px-5 lg:text-caption-12'>
                                ناموجود
                            </span>}
                    </div>
                </>}
        </div>;
};
export default ProductCard;